import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import React from 'react'
import { useTranslation } from 'react-i18next'
import UnifiedReportGeneratorDialog from '../../dialogs/unified-report-generator/UnifiedReportGeneratorDialog'
import { useDialogCtx } from '../../hooks/context-hooks'
import { GridActionButton } from '../common/GridActionButton'

interface UnifiedReportButtonProps {
  customerId: number
  customerName: string
}

const UnifiedReportButton: React.FC<UnifiedReportButtonProps> = ({ customerId, customerName }) => {
  const { showDialog } = useDialogCtx()
  const { t } = useTranslation('common')

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    showDialog(
      UnifiedReportGeneratorDialog,
      {
        componentProps: { customerId, customerName },
        opts: { maxWidth: 'lg', fullWidth: true },
      },
      undefined,
      true,
    )
  }

  return (
    <GridActionButton
      buttonIcon={<ArticleOutlinedIcon />}
      variant="outlined"
      shadowWeight={0}
      width="44px"
      height="44px"
      onClick={handleClick}
      toolTipTitle={t('reports', { ns: 'common' })}
    />
  )
}

export default UnifiedReportButton
